<template>
  <div class="icons">
    <a href="https://www.facebook.com/shanicoaching/" target="_blank">
      <img
        alt="My Facebook Page"
        data-type="image"
        itemprop="image"
        src="../assets/facebook.svg"
      />
    </a>
    <a
      href="https://www.instagram.com/shanicoaching/?fbclid=IwAR3CAbPLGh-eUDgfeYjxusAWuRCX2RHjT3HZbEXYlkjvTtnGG-Xpa30EGQo"
      target="_blank"
    >
      <img
        alt="My Instagram Account"
        data-type="image"
        itemprop="image"
        src="../assets/instagram.svg"
      />
    </a>
    <a
      href="https://www.linkedin.com/in/shani-tsadik-0a959888/"
      target="_blank"
    >
      <img
        alt="My LinkedIn Account"
        data-type="image"
        itemprop="image"
        src="../assets/linkedin.svg"
      />
    </a>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped lang="scss">
.icons {
  margin: auto;
  max-width: 600px;
  overflow: hidden;
  padding: 30px 20px;

  a {
    margin-right: 15px;
  }
}
</style>
